/**
 * Deadlock Analyzer Feature Module
 *
 * Registers the `deadlock-analyzer` workspace type (import/inspect SQL Server
 * deadlock reports without a connection). Registration side effect only — the
 * tab component (and its @xyflow/react dependency) stays behind the lazy chunk.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

registerWorkspaceComponent(
  'deadlock-analyzer',
  lazyWorkspaceTab(() => import('./components/DeadlockAnalyzerTab').then((m) => ({ default: m.DeadlockAnalyzerTab }))),
);
